module.exports = __webpack_public_path__ + "img/heroPlainHover.4e010ef8.png";